import { AppAnalytics } from './app-analytics.model';

/**
 * Interface for the 'PowerlaneAnalytics' data
 */
export interface PowerlaneAnalyticsEntity {
  id: string | number; // Primary ID
}

export class PowerLaneAppAnalytics extends AppAnalytics {
  event: AnalyticEvents;
  mediaAddedFromLocation?: string;
  constructor(obj?: any) {
    super();
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export enum AnalyticEvents {
  CREATED = 'created',
  UPDATED = 'updated',
  DELETED = 'deleted',
  MEDIAADDED = 'media_added',
  MEDIAVIDEOADDED = 'media_video_added',
  MEDIAIMAGEADDED = 'media_image_added',
  VCRSENT = 'vcr_sent',
  VCRWITHMEDIASENT = 'vcr_with_media_sent',
  VCROPENED = 'vcr_opened',
  VCRCONFIRMED = 'vcr_confirmed',
  VCRMEDIACLICKED = 'vcr_media_clicked',
  PAIDONLINE = 'paid_online',
}
